import * as React from 'react'
import Errors from '../../common/components/errors'
import {
    AMOUNT_INVALID,
    CLAIM_ENTRY_REQUIRED,
    EXCESS_DUPLICATE,
    EXCESS_ENTRY_REQUIRED,
    OTHER_EXCESS_CODE,
    ClaimHistoryDetailApi,
    ExcessHistoryDetailApi,
    SelectOption,
    claimAmount,
    claimMonth,
    claimMonthOptions,
    claimStatusOptions,
    claimTotals,
    claimTypeLabel,
    claimYear,
    claimYearOptions,
    excessTypeLabel,
    formatDollar,
    hasExcessType,
    parseAmount,
    toClaimHistoryDetail,
    toExcessHistoryDetail,
} from '../simplified-quoting'
import './duty-of-disclosure-rows.css'


function SelectControl(props: { id: string, label: string, value: string, options: SelectOption[], onChange: (value: string) => void }) {
    return (
        <div className="col-12 col-sm-6 dod-entry-col">
            <label className="input-label form-control-label" htmlFor={props.id}>{props.label}</label>
            <select
                id={props.id}
                className="form-control"
                value={props.value}
                onChange={e => props.onChange(e.target.value)}
            >
                <option value=""></option>
                {props.options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
            </select>
        </div>
    )
}


export class ExcessRows extends React.Component<any, any> {

    constructor(props) {
        super(props)
        this.state = { entryType: '', entryOther: '', entryAmount: '', entryError: '' }
    }

    onAdd() {
        const amount = parseAmount(this.state.entryAmount)
        const entryType = this.state.entryType
        if (!entryType || isNaN(amount) || (entryType === OTHER_EXCESS_CODE && this.state.entryOther.trim() === '')) {
            this.setState({ entryError: EXCESS_ENTRY_REQUIRED })
            return
        }
        if (amount <= 0) {
            this.setState({ entryError: AMOUNT_INVALID })
            return
        }
        const detail = toExcessHistoryDetail(entryType, this.state.entryOther, amount)
        if (!detail) {
            this.setState({ entryError: EXCESS_ENTRY_REQUIRED })
            return
        }
        if (hasExcessType(this.props.rows, detail.type)) {
            this.setState({ entryError: EXCESS_DUPLICATE })
            return
        }
        this.props.onChange((this.props.rows || []).concat([detail]))
        this.setState({ entryType: '', entryOther: '', entryAmount: '', entryError: '' })
    }

    onRemove(index) {
        this.props.onChange((this.props.rows || []).filter((_, rowIndex) => rowIndex !== index))
    }

    render() {
        if (!this.props.visible) return null
        const rows: ExcessHistoryDetailApi[] = this.props.rows || []
        const options: SelectOption[] = this.props.options || []
        return (
            <div className="col-12 dod-history">
                <div className="row">
                    <SelectControl id="excess-type" label="Excess Type" value={this.state.entryType} options={options} onChange={value => this.setState({ entryType: value, entryError: '' })} />
                    <div className="col-12 col-sm-6 dod-entry-col">
                        <label className="input-label form-control-label" htmlFor="excess-amount">Imposed Excess Amount</label>
                        <div className="input-group">
                            <span className="input-group-addon"><i className="fa fa-usd" aria-hidden="true"></i></span>
                            <input id="excess-amount" className="form-control" value={this.state.entryAmount} onChange={e => this.setState({ entryAmount: e.target.value.replace(/[^0-9.]/g, ''), entryError: '' })} />
                        </div>
                    </div>
                    {this.state.entryType === OTHER_EXCESS_CODE &&
                        <div className="col-12 dod-entry-col">
                            <label className="input-label form-control-label" htmlFor="excess-other">Other Excess Type</label>
                            <input id="excess-other" className="form-control" maxLength={255} value={this.state.entryOther} onChange={e => this.setState({ entryOther: e.target.value, entryError: '' })} />
                        </div>
                    }
                </div>
                <button type="button" className="btn btn-primary dod-add" onClick={this.onAdd.bind(this)}>Add</button>
                {this.state.entryError && <div className="errors"><div className="form-control-feedback"><i className="fa fa-exclamation-circle" aria-hidden="true"></i> {this.state.entryError}</div></div>}
                <div id="excessHistoryDetails" className={this.props.errors && this.props.errors.length > 0 ? 'has-danger' : ''}>
                    <Errors errors={this.props.errors} />
                </div>
                {rows.length > 0 &&
                    <table className="table table-bordered dod-history-table">
                        <thead>
                            <tr>
                                <th>Excess Type</th>
                                <th>Imposed Excess Amount</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) =>
                                <tr key={index}>
                                    <td>{excessTypeLabel(row, options)}</td>
                                    <td>{formatDollar(row.amount)}</td>
                                    <td><button type="button" className="btn btn-link dod-remove" onClick={() => this.onRemove(index)}><i className="fa fa-trash" aria-hidden="true"></i></button></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}


export class ClaimRows extends React.Component<any, any> {

    constructor(props) {
        super(props)
        this.state = {
            entryYear: '',
            entryMonth: '',
            entryStatus: 'Closed',
            entryType: '',
            entryDetails: '',
            entryAmount: '',
            entryError: '',
        }
    }

    onAdd() {
        const amount = parseAmount(this.state.entryAmount)
        if (!this.state.entryYear || !this.state.entryMonth || !this.state.entryType || isNaN(amount)) {
            this.setState({ entryError: CLAIM_ENTRY_REQUIRED })
            return
        }
        if (amount <= 0) {
            this.setState({ entryError: AMOUNT_INVALID })
            return
        }
        const detail = toClaimHistoryDetail({
            year: this.state.entryYear,
            month: this.state.entryMonth,
            status: this.state.entryStatus || 'Closed',
            code: this.state.entryType,
            details: this.state.entryDetails,
            amount: amount,
        })
        if (!detail) {
            this.setState({ entryError: CLAIM_ENTRY_REQUIRED })
            return
        }
        this.props.onChange((this.props.rows || []).concat([detail]))
        this.setState({
            entryYear: '',
            entryMonth: '',
            entryStatus: 'Closed',
            entryType: '',
            entryDetails: '',
            entryAmount: '',
            entryError: '',
        })
    }

    onRemove(index) {
        this.props.onChange((this.props.rows || []).filter((_, rowIndex) => rowIndex !== index))
    }

    render() {
        if (!this.props.visible) return null
        const rows: ClaimHistoryDetailApi[] = this.props.rows || []
        const options: SelectOption[] = this.props.options || []
        const totals = claimTotals(rows)
        return (
            <div className="col-12 dod-history">
                <div className="row">
                    <SelectControl id="claim-year" label="Year" value={this.state.entryYear} options={claimYearOptions(this.props.startDate)} onChange={value => this.setState({ entryYear: value, entryError: '' })} />
                    <SelectControl id="claim-month" label="Month" value={this.state.entryMonth} options={claimMonthOptions()} onChange={value => this.setState({ entryMonth: value, entryError: '' })} />
                    <SelectControl id="claim-status" label="Claim Status" value={this.state.entryStatus} options={claimStatusOptions()} onChange={value => this.setState({ entryStatus: value, entryError: '' })} />
                    <SelectControl id="claim-type" label="Type of Loss" value={this.state.entryType} options={options} onChange={value => this.setState({ entryType: value, entryError: '' })} />
                    <div className="col-12 col-sm-6 dod-entry-col">
                        <label className="input-label form-control-label" htmlFor="claim-amount">Amount</label>
                        <div className="input-group">
                            <span className="input-group-addon"><i className="fa fa-usd" aria-hidden="true"></i></span>
                            <input id="claim-amount" className="form-control" value={this.state.entryAmount} onChange={e => this.setState({ entryAmount: e.target.value.replace(/[^0-9.]/g, ''), entryError: '' })} />
                        </div>
                    </div>
                    <div className="dod-entry-line"></div>
                    <div className="col-12 col-sm-6 dod-entry-col">
                        <label className="input-label form-control-label" htmlFor="claim-details">Additional Details</label>
                        <input id="claim-details" className="form-control" maxLength={255} value={this.state.entryDetails} onChange={e => this.setState({ entryDetails: e.target.value.replace(/[0-9]/g, '').slice(0, 255), entryError: '' })} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary dod-add" onClick={this.onAdd.bind(this)}>Add</button>
                {this.state.entryError && <div className="errors"><div className="form-control-feedback"><i className="fa fa-exclamation-circle" aria-hidden="true"></i> {this.state.entryError}</div></div>}
                <div id="claimsHistoryDetailApi" className={this.props.errors && this.props.errors.length > 0 ? 'has-danger' : ''}>
                    <Errors errors={this.props.errors} />
                </div>
                {rows.length > 0 &&
                    <div>
                        <table className="table table-bordered dod-history-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Month</th>
                                    <th>Claim Status</th>
                                    <th>Type of Loss</th>
                                    <th>Additional Details</th>
                                    <th>Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) =>
                                    <tr key={index}>
                                        <td>{claimYear(row)}</td>
                                        <td>{claimMonth(row)}</td>
                                        <td>{row.claimStatus}</td>
                                        <td>{claimTypeLabel(row.claimType, options)}</td>
                                        <td>{row.claimDescription}</td>
                                        <td>{formatDollar(claimAmount(row))}</td>
                                        <td><button type="button" className="btn btn-link dod-remove" onClick={() => this.onRemove(index)}><i className="fa fa-trash" aria-hidden="true"></i></button></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
                <div className="dod-history-totals">
                    <div>
                        <div className="dod-total-label">Number of Claims</div>
                        <div>{totals.numberOfClaims}</div>
                    </div>
                    <div>
                        <div className="dod-total-label">Claims Amount</div>
                        <div>{formatDollar(totals.valueOfClaims)}</div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/components/duty-of-disclosure-rows.tsx